import React from 'react'
import { storiesOf } from '@storybook/react'

import { IContest, ContestStatus, ContestGoal } from 'protos'

import EventList from 'components/EventList'

const time = (delta: number = 0) => Math.round(Date.now() / 1000) + delta

const contests: IContest[] = [{
  contestId: 'a',
  title: 'Manager of the Month',
  topPrize: [{ money: { currency: 0, value: 150 }}],
  bannerUrl: 'https://res.cloudinary.com/hbngg1ybz/image/upload/q_auto:good/v1509361732/contests/Playoff_presi.jpg',
  status: ContestStatus.CS_LIVE,
  goal: { type: ContestGoal.Type.CGT_TOTAL_WINNINGS },
  endTime: time(3610),
}, {
  contestId: 'b',
  title: 'Nations League A',
  topPrize: [{ money: { currency: 0, value: 150 }}],
  bannerUrl: 'https://res.cloudinary.com/hbngg1ybz/image/upload/v1528728800/contests/imago31216473h_foosio.jpg',
  status: ContestStatus.CS_UPCOMING,
  goal: { type: ContestGoal.Type.CGT_TOTAL_GAMES },
  startTime: time(7210),
}]

storiesOf('EventList', module)
  .add('default', () => (
    <EventList contests={contests} />
  ))
